import React from "react";
import classNames from "classnames";
import Validation from "./Validation";

const Textarea = ({
  id,
  name,
  className,
  rows = 3,
  placeholder,
  autoComplete,
  ariaDescribedby,
  ariaLabelledby,
  ariaLabel,
  title,
  size,
  disabled,
  readOnly,
  value,
  isValid,
  isTouched,
  invalidFeedback,
  validFeedback,
  isValidMessage = true,
  isTooltipFeedback,
  onBlur,
  onChange,
  onFocus,
  onInput,
  onInvalid,
  onSelect,
  required,
  ...props
}) => {
  return (
    <>
      <textarea
        id={id}
        className={classNames(
          {
            "form-control": readOnly !== "plaintext",
            "form-control-plaintext": readOnly === "plaintext",
            [`form-control-${size}`]: size,
            "is-invalid": !isValid && isTouched && invalidFeedback,
            "is-valid": !isValid && isTouched && !invalidFeedback,
          },
          className
        )}
        rows={rows}
        name={name}
        title={title}
        disabled={disabled}
        readOnly={!!readOnly}
        placeholder={placeholder}
        autoComplete={autoComplete}
        aria-describedby={ariaDescribedby}
        aria-label={ariaLabel}
        aria-labelledby={ariaLabelledby}
        value={value}
        onBlur={onBlur}
        onChange={onChange}
        onFocus={onFocus}
        onInput={onInput}
        onInvalid={onInvalid}
        onSelect={onSelect}
        required={required}
        {...props}
      />
      {isValidMessage && (
        <Validation
          isTouched={isTouched}
          invalidFeedback={invalidFeedback}
          validFeedback={validFeedback}
          isTooltip={isTooltipFeedback}
        />
      )}
    </>
  );
};

export default Textarea;
